import { render, staticRenderFns } from "./JLindex.vue?vue&type=template&id=043d547f&scoped=true"
import script from "./JLindex.vue?vue&type=script&lang=js"
export * from "./JLindex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043d547f",
  null
  
)

export default component.exports